"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideBySideLightFocus = void 0;
var _react = _interopRequireDefault(require("react"));
var SideBySideLightFocus = exports.SideBySideLightFocus = function SideBySideLightFocus() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "96",
    height: "54",
    viewBox: "0 0 96 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_3427_325156)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "47",
    height: "53",
    rx: "1.5",
    fill: "#6E7391"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24 27.5C25.6406 27.5 27 26.1641 27 24.5C27 22.8594 25.6406 21.5 24 21.5C22.3359 21.5 21 22.8594 21 24.5C21 26.1641 22.3359 27.5 24 27.5ZM26.0859 28.25H25.6875C25.1719 28.5078 24.6094 28.625 24 28.625C23.3906 28.625 22.8047 28.5078 22.2891 28.25H21.8906C20.1562 28.25 18.75 29.6797 18.75 31.4141V32.375C18.75 33.0078 19.2422 33.5 19.875 33.5H28.125C28.7344 33.5 29.25 33.0078 29.25 32.375V31.4141C29.25 29.6797 27.8203 28.25 26.0859 28.25Z",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "47",
    height: "53",
    rx: "1.5",
    stroke: "#B8BBCC"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "48.5",
    y: "0.5",
    width: "47",
    height: "53",
    rx: "1.5",
    fill: "#6E7391"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M72 27.5C73.6406 27.5 75 26.1641 75 24.5C75 22.8594 73.6406 21.5 72 21.5C70.3359 21.5 69 22.8594 69 24.5C69 26.1641 70.3359 27.5 72 27.5ZM74.0859 28.25H73.6875C73.1719 28.5078 72.6094 28.625 72 28.625C71.3906 28.625 70.8047 28.5078 70.2891 28.25H69.8906C68.1562 28.25 66.75 29.6797 66.75 31.4141V32.375C66.75 33.0078 67.2422 33.5 67.875 33.5H76.125C76.7344 33.5 77.25 33.0078 77.25 32.375V31.4141C77.25 29.6797 75.8203 28.25 74.0859 28.25Z",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "48.5",
    y: "0.5",
    width: "47",
    height: "53",
    rx: "1.5",
    stroke: "#B8BBCC"
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "94",
    height: "52",
    stroke: "#B8BBCC",
    strokeWidth: "2"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_3427_325156"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "96",
    height: "54",
    fill: "white"
  }))));
};